import Base from "@/controllers/base";
import { Calendar } from "fullcalendar";
import { format } from "date-fns";
export default class DayLog extends Base {
  constructor(elem) {
    super(elem);
    this.userId = this.elem.dataset.id;
  }
  init() {
    const url = this.elem.dataset.url;
    this.calendar = new Calendar(this.elem, {
      initialView: "dayGridMonth",
      events: url,
      dateClick: (info) => {
        var date = format(info.date, "yyyy-MM-dd");
        var url = `/truckers/${this.userId}/day_logs/new?date=${date}`;
        Dialog.open({ width: "720", height: "800", title: "Daily Log", url });
      },
      eventClick: (info) => {
        var url = `/truckers/${this.userId}/day_logs/${info.event.id}`;
        Dialog.open({ width: "720", height: "800", title: "Daily Log", url });
      },
    });

    this.calendar.render();

    window.addEventListener(`day-log-${this.userId}`, this.refresh.bind(this));
  }

  refresh() {
    this.calendar.refetchEvents();
  }
}
